// services/grabacion/index.js
import api from "services/api";

const ENDPOINT = "/recordType";

const unwrapRows = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.page)) return data.page;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

/**
 * listRecordTypes
 * - Soporta paginación/orden/búsqueda vía params (ej. __limit, __offset, __sort, etc.)
 * - Devuelve siempre { rows, total } como en sellos/géneros
 */
export async function listRecordTypes(params = {}) {
  const { data } = await api.get(ENDPOINT, { params });

  const rows = unwrapRows(data);
  const total =
    data?.total ??
    data?.count ??
    data?.totalCount ??
    (typeof data?.pagination?.total === "number" ? data.pagination.total : rows.length);

  return { rows, total };
}

export async function getRecordType(id) {
  const { data } = await api.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data ?? {};
}

export async function createRecordType(payload) {
  const { data } = await api.post(ENDPOINT, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function updateRecordType(id, payload) {
  const { data } = await api.put(`${ENDPOINT}/${encodeURIComponent(id)}`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function deleteRecordType(id) {
  const { data } = await api.delete(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data;
}
